import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = () => ({
  content: null,
  selectedRegionTid: '',
});

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
